export default ".ds{\n    height: 95%;\n    width: 100%;\n    top: 5%;\n    position: absolute;\n}\n";